"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useRecommendationCosts = require("../../../../hooks/recommendation/useRecommendationCosts");
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../../services");
var _recommendationSelectors = require("../../../../store/recommendation/recommendationSelectors");
var _useAppSelector = require("../../../../hooks/useAppSelector");
var _useConfig = _interopRequireDefault(require("../../../../hooks/useConfig"));
var _useCustomer = require("../../../../hooks/questionnaire/useCustomer");
var _useQuestionsMetadata = require("../../../../hooks/questionnaire/useQuestionsMetadata");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable @typescript-eslint/no-explicit-any */

// import DiscountPill from './DiscountPill';

// const DiscountWrapper = styled.div`
//   max-width: max-content;
//   margin-bottom: 8px;
//   ${Mixins.respondTo.md(
//     css`
//       margin-left: 8px;
//       margin-bottom: 0;
//     `,
//   )}
// `;
const EntelSummarySection = _ref => {
  let {
    testId = null
  } = _ref;
  const {
    handset,
    plan,
    additionalPlans,
    broadband,
    businessSolution,
    connectivityPlan,
    totalUpfrontCost,
    totalTermCost,
    totalTermCostAfterDiscount,
    discountPrices,
    handsetUpfrontCost
  } = (0, _useRecommendationCosts.useRecommendationCosts)();
  const handsetTermCost = handset === null || handset === void 0 ? void 0 : handset.termCost;

  //---------------- Hooks -----------------

  const numberOfPlans = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectAdditionalPlans);
  const breakPoints = (0, _r10SourceLibrary.useBreakpoints)();
  const {
    isCustomer
  } = (0, _useCustomer.useCustomer)();
  const metadata = (0, _useQuestionsMetadata.useQuestionsMetadata)();
  const basicPlanIds = (0, _useConfig.default)('basicPlanIds', []);
  const hidePriceAfterDiscount = (0, _useConfig.default)('hidePriceAfterDiscount', false);
  const minimumDiscount = (0, _useConfig.default)('minimumDiscount', 10);
  const isSmallScreen = breakPoints.sm;
  const showFullPlanName = (0, _useConfig.default)('showFullPlanName', true);
  const planIdWithDifferentHeader = (0, _useConfig.default)('planIdWithDifferentHeader', []);

  //------- Calculations and Parsers -------

  const products = [handset, {
    ...plan,
    additional: additionalPlans
  }, broadband, businessSolution, connectivityPlan].filter(product => !!product);

  // Instantiate the parser

  const Parser = (0, _react.useMemo)(() => new _services.Parsers.RecommendationSummaryParser({
    totalTermCost,
    totalTermCostAfterDiscount,
    totalUpfrontCost,
    discountPrices,
    numberOfPlans,
    hidePriceAfterDiscount,
    metadata,
    isCustomer,
    basicPlanIds,
    handsetUpfrontCost,
    products,
    minimumDiscount,
    isSmallScreen,
    handsetTermCost,
    plan,
    showFullPlanName,
    planIdWithDifferentHeader
  }), [totalTermCost, totalTermCostAfterDiscount, totalUpfrontCost, discountPrices, numberOfPlans, hidePriceAfterDiscount, metadata, isCustomer, basicPlanIds, handsetUpfrontCost, products, minimumDiscount, isSmallScreen, handsetTermCost, plan, showFullPlanName, planIdWithDifferentHeader]);
  // Get the values from the parser
  const {
    columns
  } = Parser.RecommendationSummaryValues;
  //Styling props
  const flexDirection = (0, _react.useMemo)(() => breakPoints.sm ? 'column' : 'row', [breakPoints]);
  const flexBasis = (0, _react.useMemo)(() => columns === 2 ? '50%' : '33%', [columns]);
  const SummaryComponent = () => Parser.getRecommendationSummaryComponent({
    testId,
    flexBasis,
    isCustomer,
    breakPoints,
    flexDirection
  });
  return /*#__PURE__*/_react.default.createElement(SummaryComponent, null);
};
var _default = EntelSummarySection;
exports.default = _default;